<template>
  <div>
    <div class="info">
      <div class="user-info">
        <img src="../../../assets/img/avatar.png" class="avatar" alt />
        <span>{{userInfo.userName}}</span>
      </div>
      <div class="system">{{cashierData.goodsName}}</div>
    </div>
    <div class="content">
      <div class="left">
        <div class="title">订阅享特权</div>
        <ul class="mode-wrap">
          <li class="mode" v-for="val in cashierData.list[0].goodsMenu.split(',')" :key="val">
            <i></i>
            {{val}}
          </li>
        </ul>
        <el-button>了解特权详情</el-button>
      </div>
      <div class="right">
        <div class="price-wrap">
          <div class="item-wrap" v-for="(val,key) in cashierData.list" :key="key">
            <div
              class="item"
              :class="{'active':activeIndex === key}"
              @click="handlePriceChange(key)"
            >
              <div class="type">1{{val.time}}</div>
              <div class="price">
                <span class="symbol">￥</span>
                {{val.curPrice}}
              </div>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="手机支付" name="first">
            <div class="qr-code">
              <vue-qr class="code" :text="imgUrl" :size="130" :logoSrc="logo" :logoScale="0.2"></vue-qr>
              <div class="pay">
                <div class="pay-info">
                  实付：
                  <span class="symbol">￥</span>
                  <span class="amount">{{amount}}</span>
                </div>
                <div class="pay-type">
                  <img class="wx" src="../../../assets/img/wx.png" alt />
                  微信扫码支付
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="线下汇款" name="second">
            <div class="qr-code offline">
              <p>名称：北京腾景数字科技发展有限责任公司</p>
              <p>地址：北京市朝阳区朝外大街乙6号25层2901</p>
              <p>电话：010-65185898</p>
              <p>开户行：招商银行北京自贸试验区商务中心区支行</p>
              <p>账号：1109 4611 7410 301</p>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="agreement">
          <el-popover placement="top" width="400" trigger="click">
            <div>
              <div>1.付款方式：6000元以下可采用手机支付方式，支付成功后自动开通相应权限；6000元以上请联系客服进行线下汇款，收到款项后我们会在一个工作日内为您开通权限。</div>
              <div>2.使用期限：使用期是从付费成功当日起开始计时。</div>
              <div>
                3.发票开具：如需开具发票请于购买后60天内提交开票申请，发票内容为“咨询服务费”。发票开具流程为：登录账号，在用户名称下拉菜单中点击“个人订单”进入订单页面，选择需要开具发票的订单，点击“开具发票”，填写信息并提交即可。
                <span class="impor">默认开具电子发票，如需纸质发票请在备注栏中注明“纸质发票”！</span>
                纸质发票审核通过后，我们会在7个工作日内尽快寄出，快递费用一律为到付。
              </div>
              <div>客服在线时间：9:00-17:00（工作日）</div>
              <div>联系方式：010-65185895</div>
            </div>
            <span slot="reference" class="price">《价格说明》</span>
          </el-popover>
          <span>《腾景数据库用户协议》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pay } from "@/api/product";
import { permissions } from "@/api/login";

import VueQr from "vue-qr";
import { mapState } from "vuex";
export default {
  props: ["cashierData"],
  data() {
    return {
      activeName: "first",
      activeIndex: 0,
      orderInfo: {},
      imgUrl: "",
      logo: require("../../../assets/img/avatar.png"),
      orderResult: {
        orderNo: "",
        result: ""
      },
      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 28 * 1000, //30秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null //断开 重连倒计时
    };
  },
  components: {
    VueQr
  },

  computed: {
    ...mapState(["userInfo"]),
    amount() {
      return this.cashierData.list[this.activeIndex].curPrice;
    }
  },
  watch: {
    activeIndex() {
      this.handlePay();
    }
  },
  created() {
    this.handlePay();
  },
  destroyed() {
    //页面销毁时关闭长连接
    this.websocketclose();
  },
  methods: {
    handlePriceChange(key) {
      this.activeIndex = key;
    },
    async handlePay() {
      let obj = this.cashierData.list[this.activeIndex];
      let { data } = await pay({
        orderNo: "",
        goodsIds: obj.id,
        goodsTime: 1 + obj.time,
        goodsDesc: obj.goodsName,
        amount: obj.curPrice,
        tunnelType: "01",
        tunnelPayType: "01"
      });
      if (data.resultBody) {
        this.orderResult = data.resultBody;
        this.imgUrl = JSON.parse(data.resultBody.result).code_url;
        this.$emit("orderResult", this.orderResult);
      }
      this.initWebSocket();
    },
    initWebSocket() {
      //建立连接
      //初始化websocket
      // const wsurl = `ws://guanwang.tj.cn:80/wspayment/trade/${this.orderResult.orderNo}`;
      let wsurl;
      if (process.env.NODE_ENV == "production") {
        wsurl = `ws://www.tjresearch.cn/wspayment/trade/${this.orderResult.orderNo}`;
      } else {
        wsurl = `ws://guanwang.tj.cn/wspayment/trade/${this.orderResult.orderNo}`;
      }
      //建立连接
      this.websock = new WebSocket(wsurl);
      //连接成功
      this.websock.onopen = this.websocketonopen;
      //连接错误
      this.websock.onerror = this.websocketonerror;
      //接收信息
      this.websock.onmessage = this.websocketonmessage;
      //连接关闭
      this.websock.onclose = this.websocketclose;
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function() {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState == 1) {
          //如果连接正常
          self.websock.send("heartCheck");
          // console.log('-------------')
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function() {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    websocketonopen() {
      //连接成功事件
      //提示成功
      console.log("连接成功");
      //开启心跳
      this.start();
    },
    websocketonerror() {
      //连接失败事件
      //错误
      console.log("WebSocket连接发生错误");
      //错误提示
      console.log("Websocket error, Check you internet!");
      //重连
      this.reconnect();
    },
    websocketclose() {
      //连接关闭事件
      //关闭
      // console.log("connection closed (" + e.code + ")");
      //提示关闭
      console.log("连接已关闭", 333);
      //重连
      // this.reconnect();
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
      this.timeoutnum && clearTimeout(this.timeoutnum);
    },
    websocketonmessage(event) {
      //接收服务器推送的信息
      //打印收到服务器的内容
      if (event.data == "02") {
        this.showPayResult();
      } else if (event.data == "03") {
        this.showPayError();
      }
      //收到服务器信息，心跳重置
      this.reset();
    },
    websocketsend(msg) {
      //向服务器发送信息
      //数据发送
      this.websock.send(msg);
    },
    async showPayResult() {
      // 支付成功
      this.$emit("showDialog", 3);
      await permissions();
    },
    showPayError() {
      this.$emit("showDialog", 6);
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  height: 130px;
  background: url("../../../assets/img/cashier.jpg") no-repeat center/cover;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  .user-info {
    padding-left: 46px;
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #ebeff0;
    .avatar {
      height: 40px;
      width: 40px;
      padding-right: 26px;
    }
  }
  .system {
    position: absolute;
    left: 0;
    bottom: 0;
    color: #6a4300;
    font-size: 22px;
    background-image: linear-gradient(to left, #e2ad51, #f8cd88);
    padding: 14px 50px;
    border-top-right-radius: 70px;
    border-top-left-radius: 70px;
  }
}
.content {
  background: #eee;
  display: flex;
  padding: 26px 46px;
  .left {
    background: #fff;
    width: 220px;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 10px;
    .title {
      color: #eba426;
      font-size: 22px;
      margin-bottom: 26px;
    }
    .mode-wrap {
      list-style: none;
      padding: 0;
      .mode {
        color: #202020;
        font-size: 16px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          height: 11px;
          width: 11px;
          background: #202020;
          border: 1px solid #a8a8a8;
          margin-right: 14px;
          margin-top: 2px;
        }
      }
    }
  }
  .right {
    flex: 1;
    padding: 0 5px;
    .price-wrap {
      display: flex;
      flex-wrap: wrap;
      .item-wrap {
        width: 33%;
        padding: 0 5px;
        box-sizing: border-box;
        .item {
          background: #fff;
          text-align: center;
          padding: 26px 0;
          border-radius: 10px;
          border: 1px solid #fff;
          cursor: pointer;
          &.active {
            background: #fffcf5;
            border-color: #edcc96;
          }
          .type {
            color: #1f2024;
            font-size: 18px;
            margin-bottom: 26px;
          }
          .price {
            color: #fe6c07;
            font-weight: bold;
            font-size: 26px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            .symbol {
              font-size: 14px;
              padding: 0 4px 4px 0;
            }
          }
        }
      }
    }
    .el-tabs {
      margin-top: 40px;
      margin-left: 5px;
      .el-tabs__item {
        background: #fff;
        border: 1px solid #fff;
        border-top-right-radius: 40px;
        padding-right: 50px;
        &.is-active {
          background: #fffcf5;
          border-color: #edcc96;
          border-bottom: none;
        }
      }
      .qr-code {
        background: #fff;
        padding: 18px;
        display: flex;
        color: #010101;
        font-size: 14px;
        height: 162px;
        box-sizing: border-box;
        &.offline {
          flex-direction: column;
          p {
            margin: 2px;
            font-size: 14px;
          }
        }
        .code {
          height: 130px;
          width: 130px;
          padding-right: 20px;
        }
        .pay {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .pay-info {
            margin-bottom: 26px;
            .symbol {
              color: #ff6a09;
              font-size: 14px;
            }
            .amount {
              color: #ff6a09;
              font-size: 22px;
              font-weight: bold;
            }
          }
          .pay-type {
            display: flex;
            align-items: center;
            .wx {
              height: 20px;
              width: auto;
              padding-right: 4px;
            }
          }
        }
      }
    }
    .agreement {
      text-align: right;
      margin-top: 18px;
      font-size: 14px;
    }
  }
}
</style>